import SideTool from "@/global/components/side-tool";

export default function ConsititutiveRelationship() {
    return (
        <div>
            <SideTool />
            consititutive-relationship
        </div>
    )
}